export default "__VITE_ASSET__C_Maa8An__"